import {createAction} from '@reduxjs/toolkit';

export const add = createAction('sessionParams/add');
export const clear = createAction('sessionParams/clear');